import { Outlet } from "react-router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const Layout = () => {
  return (
    <>
      <div>
        <Outlet />
        <ToastContainer />
      </div>
    </>
  );
};
